import { useEffect, useRef } from "react";
export const useOutsideClick = (onClick, excludeRef) => {
    const ref = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            const target = event.target;
            const isOutsideMenu = ref.current && !ref.current.contains(target);
            const isOnExcludedElement = (excludeRef === null || excludeRef === void 0 ? void 0 : excludeRef.current) && excludeRef.current.contains(target);
            if (isOutsideMenu && !isOnExcludedElement) {
                onClick();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [onClick, excludeRef]);
    return ref;
};
